module.exports = __webpack_public_path__ + "static/img/user.e5bc9cd1.png";